import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asset-control-reports',
  templateUrl: './asset-control-reports.component.html',
  styleUrls: ['./asset-control-reports.component.scss']
})
export class AssetControlReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
